<template>
<modal name="baton-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeBatonDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/yagishcareer_logo.png" style="width:90%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
        <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
        Yagish Carrerの<a href="https://career.yagish.jp/term.html" target="_blank">利用規約</a>、<a href="https://career.yagish.jp/privacy.html" target="_blank">個人情報保護方針</a><br/>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isBatonSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-baton-consult');">希望する</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isBatonSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeBatonDialog();">送信しました</el-button>
      <br/>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 2">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">もうすぐで完了するよ！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/baton_career_yagish_logo.jpeg" style="width:90%" >
        </p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
        ㈱バトンコネクトの<a href="https://baton-connect.co.jp/%e5%88%a9%e7%94%a8%e8%a6%8f%e7%b4%84/?fbclid=IwAR1w1RARzR-aTjq6vNMjT5jrA8obhhbxHiJaMO7zjo4dRU1oOp3KMlJm2iY" target="_blank">利用規約</a>、<a href="https://baton-connect.co.jp/privacy-policy/" target="_blank">個人情報保護方針</a><br/>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談や<br>求人受取、会員登録を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isBatonSended == false"
      style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
        @click="$eventHub.$emit('send-baton-consult');">規約に同意して無料相談する</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isBatonSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeBatonDialog();">送信しました</el-button>
      <br/>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isBatonSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true,
      medleyID:7,
      medleyPCLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      },
      medleySPLnks: {
        1:'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2:'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3:'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5:'https://job-medley.com/lp/dh/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6:'https://job-medley.com/lp/da/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7:'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10:'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      }
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openBatonDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('baton-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'baton_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeBatonDialog: function () {
      this.$modal.hide('baton-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendBatonConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'baton_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '3')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendBaton, formData, {timeout: 60000})
        .then(function (response) {
          app.isBatonSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'baton_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isAdtopSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMedleyConsult: async function () {
      console.error('sendMedleyConsult')
      if (!this.isAgree) {
      console.error('チェックしてから同意ボタンを押してください。')
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open(this.medleySPLnks[this.medleyID], '_blank')
      } else {
        window.open(this.medleyPCLnks[this.medleyID], '_blank')
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'baton_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendLinkMedley, formData, {timeout: 60000})
        .then(function (response) {
          app.isMedleySended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'baton_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, {timeout: 60000})
        .then(function (response) {
          app.isJigenSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-adtop-consult-baton', this.sendAdtopConsult)
    this.$eventHub.$on('send-medley-consult-baton', this.sendMedleyConsult)
    this.$eventHub.$on('send-jigen-consult-baton', this.sendJigenConsult)
    this.$eventHub.$on('send-baton-consult', this.sendBatonConsult)
    this.$eventHub.$on('open-baton-dialog', this.openBatonDialog)
    this.$eventHub.$on('popstate', this.closeBatonDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-adtop-consult-baton', this.sendAdtopConsult)
    this.$eventHub.$off('send-medley-consult-baton', this.sendMedleyConsult)
    this.$eventHub.$off('send-jigen-consult-baton', this.sendJigenConsult)
    this.$eventHub.$off('send-baton-consult', this.sendBatonConsult)
    this.$eventHub.$off('open-baton-dialog', this.openBatonDialog)
    this.$eventHub.$off('popstate', this.closeBatonDialog)
  }
}
</script>
